// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrum{
    display: flex;
    align-items: center;
    gap: 8px;
    color: #5e5e5e;
    font-size: 16px;
    font-weight: 600;
    margin: 60px 170px;
    text-transform: capitalize;
}
@media(max-width:1280px){
    .breadcrum{
        margin: 30px 50px;
        font-size: 14px;
    }

}
@media(max-width:1024px){
    .breadcrum{
        margin: 30px 30px;
        font-size: 13px;
    }

}
@media(max-width:800px){
    .breadcrum{
        margin: 30px 10px;
        font-size: 12px;
    }
}
@media(max-width:500px){
    .breadcrum{
        
        font-size: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Breadcrums/Breadcrum.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI;QACI,iBAAiB;QACjB,eAAe;IACnB;;AAEJ;AACA;IACI;QACI,iBAAiB;QACjB,eAAe;IACnB;;AAEJ;AACA;IACI;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;AACA;IACI;;QAEI,eAAe;IACnB;AACJ","sourcesContent":[".breadcrum{\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #5e5e5e;\n    font-size: 16px;\n    font-weight: 600;\n    margin: 60px 170px;\n    text-transform: capitalize;\n}\n@media(max-width:1280px){\n    .breadcrum{\n        margin: 30px 50px;\n        font-size: 14px;\n    }\n\n}\n@media(max-width:1024px){\n    .breadcrum{\n        margin: 30px 30px;\n        font-size: 13px;\n    }\n\n}\n@media(max-width:800px){\n    .breadcrum{\n        margin: 30px 10px;\n        font-size: 12px;\n    }\n}\n@media(max-width:500px){\n    .breadcrum{\n        \n        font-size: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
